import { trackEvent } from './amplitude';

/**
 * Push custom events for GTM → GA4 explorations (e.g. organic landing → signup CTA).
 * Requires GTM_ID in env (_app loads GoogleTagManager).
 *
 * Conversion mapping (do not treat GA4 `sign_up` as the trial KPI):
 * - `signupCtaClick` → CTA click (Amplitude `signup_cta_clicked`)
 * - `account_signup_completed` → real account created (Amplitude `account_signup_completed`)
 * - Trial KPI is Amplitude `free_trial_started`, not GA4 `sign_up`.
 * Do not mark page_view, CTA impression, or `/sign-up` page load as a conversion.
 */
export function pushSignupCtaClick(payload: { location: string; label?: string }) {
  if (typeof window === 'undefined') {
    return;
  }
  const w = window as Window & { dataLayer?: Record<string, unknown>[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({
    event: 'signupCtaClick',
    signup_cta_location: payload.location,
    ...(payload.label ? { signup_cta_label: payload.label } : {}),
  });

  trackEvent('signup_cta_clicked', {
    location: payload.location,
    ...(payload.label ? { label: payload.label } : {}),
  });
}

/** Fire only after a real account is created — not on page view or CTA impression. */
export function pushAccountSignupCompleted(payload: { method: string }) {
  if (typeof window === 'undefined') {
    return;
  }
  const w = window as Window & { dataLayer?: Record<string, unknown>[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({
    event: 'account_signup_completed',
    signup_method: payload.method,
  });
}

/** Derive a stable Amplitude/GTM location from a marketing pathname. */
export function getMarketingCtaLocation(asPath: string, suffix = 'hero_primary'): string {
  const path = asPath.split('?')[0].replace(/\/$/, '') || 'home';
  return `${path.replace(/^\//, '').replace(/\//g, '_')}_${suffix}`;
}
